import WConfigEditTool from '@/views/config/components/ConfigEditTool';
import WGroupSavePopup from '@/views/config/node/components/GroupSavePopup';

export default {
  components: {
    WConfigEditTool,
    WGroupSavePopup,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      activeTab: 'configStatus',
    };
  },
  computed: {
    visibleEditButton() {
      const userInfo = this.$store.getters.userInfo;
      return this.activeTab === 'WConfigStatus' && userInfo.managerType !== 'SDUSER';
    },
    isConfigEditing() {
      return this.$store.state.config.isConfigEditing;
    },
  },
  methods: {
    /**
     * 그룹 저장 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    openGroupSavePopup() {
      this.$refs.groupSavePopup.open();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/config/config-node-tab.js